import { forwardRef } from "react";

import { cn } from "@/ui/lib/utils";
import {
  CONTAINER_DEFAULTS,
  CONTAINER_SIZE_CLASS_MAP,
  TContainerProps,
} from "@/ui/components/layout/Container";

export const Container = forwardRef<HTMLDivElement, TContainerProps>(
  (
    {
      tag: Tag = CONTAINER_DEFAULTS.tag,
      "data-component": component = CONTAINER_DEFAULTS["data-component"],
      size = CONTAINER_DEFAULTS.size,
      className,
      children,
      ...props
    },
    ref,
  ) => (
    <Tag
      {...props}
      ref={ref}
      data-component={component}
      className={cn(
        "container mx-auto",
        CONTAINER_SIZE_CLASS_MAP[size],
        className,
      )}
    >
      { children }
    </Tag>
  ),
);

Container.displayName = "Container";
